import React, { useState } from "react";
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import Accordion from "./Accordion";
import FaqBanner from "./FaqBanner";
import ElevatorLoader from "../../Loder/ElevatorLoader";
import ChatbotPopup from '../../Chatbot/ChatbotPopup';

const FAQ = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <FaqBanner />
      <Accordion />
      <Contact />
      <FooterThree />
    </div>
  );
};

export default FAQ;
